//require('./bootstrap');

/**
 * App
 * ------
 * Specify vendor and app specific js files to be compiled
 */

// Bootstrap Components
require('./vendor/bootstrap/collapse');
require('./vendor/bootstrap/dropdown');
require('./vendor/bootstrap/tab');
require('./vendor/bootstrap/modal');

// Vendor Requires
require('./vendor/picturefill');
// require('./vendor/slick-slider');
require('./vendor/waypoint');
require('./vendor/waypoint-animate');
require('./vendor/parallax');
require('./vendor/js.cookie');

// App Requires
require('./app/hover-grid');
require('./app/primary-navigation');
require('./app/sticky-nav');
require('./app/parallax');
require('./app/specifications');
require('./app/info-banner');
require('./app/team-grid');
require('./app/modal');
require('./app/graph-block');
require('./app/market-data');
// require('./app/charts');
